const imageWidgets = document.querySelectorAll(".widget_media_image, .widget--sticky");
if (imageWidgets) {
	let prevItemHeight = 0;
	imageWidgets.forEach((item) => {
		item.style.top = 100 + prevItemHeight + "px";
		prevItemHeight = item.clientHeight;
	});
}